var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChapterQuestionsEditor',{attrs:{"isChecklist":"","languages":_vm.languages,"default_lang":_vm.default_lang,"id":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }